// Author YuJiaBei
// Date 2025-01-01 10:00:32

class InspectionSchedule {
constructor({
        id = null,
        inspectionCategoryId = '',
        scheduleName = '',
        executor = '',
        abnormalPlanner = '',
        periodicUnit = '',
        periodicValue = '',
        nextExecutionDate = '',
        suspensionState = '',
        description = ''}
= {}) {
    this.id = id;
    this.inspectionCategoryId = inspectionCategoryId;
    this.scheduleName = scheduleName;
    this.executor = executor;
    this.abnormalPlanner = abnormalPlanner;
    this.periodicUnit = periodicUnit;
    this.periodicValue = periodicValue;
    this.nextExecutionDate = nextExecutionDate;
    this.suspensionState = suspensionState;
    this.description = description;
}
}

function newEntity() {
return new InspectionSchedule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.inspection.inspectionSchedule.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionCategoryName',
        label: 'label.em.inspection.inspectionSchedule.grid.inspectionCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
            key: 'scheduleName',
            label: 'label.em.inspection.inspectionSchedule.grid.scheduleName',
            sortable: true,
            form: {
                type: 'input',
                customClass: (row) => {
                    //超过一天的的变红
                    if (row.executeStatusCode === 3) {
                        return "text-danger"
                    }
                    return ""
                }
            }
        },
        {
        key: 'executor',
        label: 'label.em.inspection.inspectionSchedule.grid.executor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executorName',
        label: 'label.em.inspection.inspectionSchedule.grid.executorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'departmentName',
        label: 'label.em.inspection.inspectionSchedule.grid.departmentName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'abnormalPlanner',
        label: 'label.em.inspection.inspectionSchedule.grid.abnormalPlanner',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'abnormalPlannerName',
        label: 'label.em.inspection.inspectionSchedule.grid.abnormalPlannerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.inspection.inspectionSchedule.grid.periodicUnit',
        sortable: true,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicValue',
        label: 'label.em.inspection.inspectionSchedule.grid.periodicValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.inspection.inspectionSchedule.grid.nextExecutionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lastExecutionDate',
        label: 'label.em.inspection.inspectionSchedule.grid.lastExecutionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatusCode',
        label: 'label.em.inspection.inspectionSchedule.grid.executeStatusCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatusName',
        label: 'label.em.inspection.inspectionSchedule.grid.executeStatusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatus',
        label: 'label.em.inspection.inspectionSchedule.grid.executeStatus',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'suspensionState',
        label: 'label.em.inspection.inspectionSchedule.grid.suspensionState',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeTimeoutCount',
        label: 'label.em.inspection.inspectionSchedule.grid.executeTimeoutCount',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeTimeoutRecordDate',
        label: 'label.em.inspection.inspectionSchedule.grid.executeTimeoutRecordDate',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionSchedule.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    inspectionCategoryIdFilter : '',
    scheduleNameFilter : '',
    executorFilter : '',
    departmentIdFilter : '',
    abnormalPlannerFilter : '',
    periodicUnitFilter : '',
    periodicValueFilter : '',
    greaterThanNextExecutionDateFilter : '',
    lessThanNextExecutionDateFilter : '',
    suspensionStateFilter : '',
    executeStatusCodeFilter : '',
    executeStatusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'inspectionCategoryIdFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.inspectionCategoryId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'scheduleNameFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.scheduleName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executorFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.executor',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'departmentIdFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.departmentId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'abnormalPlannerFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.abnormalPlanner',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'periodicUnitFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.periodicUnit',
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValueFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.periodicValue',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'greaterThanNextExecutionDateFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.greaterThanNextExecutionDate',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lessThanNextExecutionDateFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.lessThanNextExecutionDate',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'suspensionStateFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.suspensionState',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusFilter',
        label: 'label.em.inspection.inspectionSchedule.filter.executeStatus',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'inspectionCategoryId',
        label: 'label.em.inspection.inspectionSchedule.entity.inspectionCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'scheduleName',
        label: 'label.em.inspection.inspectionSchedule.entity.scheduleName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'executor',
        label: 'label.em.inspection.inspectionSchedule.entity.executor',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'abnormalPlanner',
        label: 'label.em.inspection.inspectionSchedule.entity.abnormalPlanner',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.inspection.inspectionSchedule.entity.periodicUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValue',
        label: 'label.em.inspection.inspectionSchedule.entity.periodicValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.inspection.inspectionSchedule.entity.nextExecutionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'suspensionState',
        label: 'label.em.inspection.inspectionSchedule.entity.suspensionState',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionSchedule.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
]

export {InspectionSchedule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
